module.exports = __webpack_public_path__ + "img/0Q3B7249_Wood.389c7efe.jpg";